import apiClient from "@/api/client";
import type {
  PricingRule,
  PricingEstimate,
  PricingEstimateRequest,
  BillingEvent,
  BillingSummary,
} from "@/types/billing";

export async function getPricingRule(): Promise<PricingRule> {
  const { data } = await apiClient.get<PricingRule>("/billing/pricing");
  return data;
}

export async function estimatePricing(
  payload: PricingEstimateRequest
): Promise<PricingEstimate> {
  const { data } = await apiClient.post<PricingEstimate>(
    "/billing/pricing/estimate",
    payload
  );
  return data;
}

export async function getBillingEvents(
  offset = 0,
  limit = 50
): Promise<BillingEvent[]> {
  const { data } = await apiClient.get<BillingEvent[]>("/billing/events", {
    params: { offset, limit },
  });
  return data;
}

export async function getBillingSummary(
  year: number,
  month: number
): Promise<BillingSummary> {
  const { data } = await apiClient.get<BillingSummary>("/billing/summary", {
    params: { year, month },
  });
  return data;
}

// ── Tenant-specific Pricing ──────────────────────────────────────────────────

export async function getTenantPricingRule(
  tenantId: number
): Promise<PricingRule | null> {
  const { data } = await apiClient.get<PricingRule | null>(
    `/billing/tenants/${tenantId}/pricing`
  );
  return data;
}

export async function saveTenantPricingRule(
  tenantId: number,
  payload: Omit<PricingRule, "id" | "tenant_id" | "is_active" | "effective_from">
): Promise<PricingRule> {
  const { data } = await apiClient.post<PricingRule>(
    `/billing/tenants/${tenantId}/pricing`,
    payload
  );
  return data;
}

export async function deleteTenantPricingRule(
  tenantId: number
): Promise<void> {
  await apiClient.delete(`/billing/tenants/${tenantId}/pricing`);
}
